module.exports = require("././dist/restangular.js");


/*****************
 ** WEBPACK FOOTER
 ** restangular (bower component)
 ** module id = 383
 ** module chunks = 1
 **/